// extracted by mini-css-extract-plugin
var _1 = "RentalPortalKeyFactsWidgetItem-moduleRentalPortalKeyFactsWidgetItem__Z8Gcn";
var _2 = "RentalPortalKeyFactsWidgetItem-modulelabel__hoSbh";
var _3 = "RentalPortalKeyFactsWidgetItem-modulelabelRow__Xdska";
var _4 = "RentalPortalKeyFactsWidgetItem-moduletext__DDQkr";
var _5 = "RentalPortalKeyFactsWidgetItem-modulevalue__KuxwT";
export { _1 as "RentalPortalKeyFactsWidgetItem", _2 as "label", _3 as "labelRow", _4 as "text", _5 as "value" }
